import * as i0 from '@angular/core';
import { Directive, HostBinding, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/card/card';
import { FadvButtonModule } from '@fa-switch-sharedservices/ng-elements/fadv-button';

class FadvCardImageDirective {
    constructor() {
        this.slotName = 'image';
    }
}
FadvCardImageDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardImageDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvCardImageDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardImageDirective, selector: "img[fadvCardImage]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardImageDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'img[fadvCardImage]' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvCardButtonDirective {
    constructor() {
        this.slotName = 'button';
    }
}
FadvCardButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvCardButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardButtonDirective, selector: "[fadvCardButton]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardButtonDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[fadvCardButton]' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvCardIconDirective {
    constructor() {
        this.slotName = 'icon';
    }
}
FadvCardIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvCardIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardIconDirective, selector: "[fadvCardIcon]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardIconDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[fadvCardIcon]' }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvCardHeaderComponent {
    constructor() {
        this.displayType = 'contents';
        this.slotName = 'header';
    }
}
FadvCardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FadvCardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardHeaderComponent, selector: "fadv-card-header", host: { properties: { "style.display": "this.displayType", "slot": "this.slotName" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-card-header', template: '<ng-content></ng-content>' }]
        }], propDecorators: { displayType: [{
                type: HostBinding,
                args: ['style.display']
            }], slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvCardBodyComponent {
}
FadvCardBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FadvCardBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardBodyComponent, selector: "fadv-card-body", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fadv-card-body', template: '<ng-content></ng-content>' }]
        }] });
class FadvCardComponent extends FadvBaseComponent {
}
FadvCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvCardComponent, selector: "fadv-card", usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-card',
                    template: '<ng-content></ng-content>',
                }]
        }] });

class FadvCardModule {
}
FadvCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvCardModule, declarations: [FadvCardComponent,
        FadvCardBodyComponent,
        FadvCardHeaderComponent,
        FadvCardImageDirective,
        FadvCardButtonDirective,
        FadvCardIconDirective], imports: [FadvCommonModule, FadvButtonModule], exports: [FadvCardComponent,
        FadvCardBodyComponent,
        FadvCardHeaderComponent,
        FadvCardImageDirective,
        FadvCardButtonDirective,
        FadvCardIconDirective] });
FadvCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardModule, imports: [FadvCommonModule, FadvButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FadvCardComponent,
                        FadvCardBodyComponent,
                        FadvCardHeaderComponent,
                        FadvCardImageDirective,
                        FadvCardButtonDirective,
                        FadvCardIconDirective,
                    ],
                    imports: [FadvCommonModule, FadvButtonModule],
                    exports: [
                        FadvCardComponent,
                        FadvCardBodyComponent,
                        FadvCardHeaderComponent,
                        FadvCardImageDirective,
                        FadvCardButtonDirective,
                        FadvCardIconDirective,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvCardBodyComponent, FadvCardButtonDirective, FadvCardComponent, FadvCardHeaderComponent, FadvCardIconDirective, FadvCardImageDirective, FadvCardModule };
